// extracted by mini-css-extract-plugin
export var container = "_9v-0";
export var fallback = "_9v-5";
export var fallbackIcon = "_9v-6";
export var hidden = "_9v-2";
export var image = "_9v-3";
export var loaded = "_9v-4";
export var placeholder = "_9v-1";